import IndexPage from '../components/IndexPage'

export default function index() {
  return <IndexPage />
}

